import { SET_CURRENT_POST } from 'actions/post';

const DEFAULT_STATE = {
  current: undefined
};

export default function post(state = DEFAULT_STATE, action) {
  switch (action.type) {
    case SET_CURRENT_POST:
      return { ...state, current: action.data };
    default:
      return state;
  }
}
